var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingOfficeStairSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dbe9fa;}.cls-2{fill:#ffffff;}.cls-3{fill:#d9dce1;}.cls-4{fill:#52acf9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stair"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 16,
    width: 2,
    x: 22,
    y: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16 16 16 20 11 20 11 24 6 24 6 28 2 28 2 30 6 30 8 30 30 30 30 16 16 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "12.61 3 13.95 7 12.61 11 24 11 24 3 12.61 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,16V2H22V3H12.61L14,7l-1.34,4H22v5H16v4H11v4H6v4H2v2H30V16ZM15.39,9l.66-2-.66-2H22V9ZM28,28H8V26h5V22h5V18H28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingOfficeStairSvgrepoCom);
export default __webpack_public_path__ + "static/media/marketing-office-stair-svgrepo-com.a806323c3b1cd157b4d2fa3e51c20661.svg";
export { ForwardRef as ReactComponent };